import {Stack} from '@mui/material';
import React from 'react';

import {translations} from 'presentation/translations-new';

import {UnitCardActions} from './components/UnitCardActions';
import {UnitCardAddress} from './components/UnitCardAddress';
import {UnitCardHeader} from './components/UnitCardHeader';
import {useUnitCard} from './hooks/useUnitCard';
import {StyledCard} from './styles';
import {UnitCardProps} from './types';
import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';

const {seeMap} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow.unitDetails;

export function UnitCard(props: UnitCardProps) {
	const {
		isTelemedicine,
		isNotSelf,
		showDistanceReference,
		nmBairroOrigem,
		phoneNumbers,
		address,
		distanceReference,
		query,
		unitName,
		isAdvanceUnit,
	} = props;

	const {
		dataTagId,
		handleOpenGoogleMaps,
		getStackDirection,
		getStackAlign,
		addressToDisplay,
		isMobile,
		distanceFilterDescription,
		formattedUnitName,
	} = useUnitCard({
		isTelemedicine,
		isNotSelf,
		showDistanceReference,
		nmBairroOrigem,
		phoneNumbers,
		address,
		unitName,
	});

	return (
		<StyledCard
			$isCursorPointer={false}
			data-tag-id={dataTagId}
			elevation={0}
			$isAdvanceUnit={isAdvanceUnit}>
			<Stack
				gap={isMobile ? 2 : 1}
				flexDirection={getStackDirection()}
				justifyContent={isMobile ? 'space-between' : undefined}
				alignItems={getStackAlign()}
				p={2}
				flex={1}>
				<Stack gap={1} height="100%">
					<UnitCardHeader unitName={unitName} query={query} />
					<UnitCardAddress
						seeMapDataTagId={`${AppointmentBookingEnum.CLICK_VER_MAPA_AGENDAMENTO}${formattedUnitName}`}
						address={addressToDisplay}
						onOpenMap={handleOpenGoogleMaps}
						seeMapLabel={seeMap.toLowerCase()}
						showDistanceReference={showDistanceReference}
						distanceFilterDescription={distanceFilterDescription}
						distanceReference={distanceReference}
					/>
				</Stack>
			</Stack>
			<UnitCardActions {...props} />
		</StyledCard>
	);
}
